<template>
  <div
    v-if="isVisible"
    class="form-error-list"
  >
    <ul class="list form-error-list__items">
      <template
        v-for="(message, key) in messages"
        :key="key"
      >
        <li
          class="list__element list__element--dashed form-error-list__item error-message"
          v-html="message"
        />
      </template>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { forIn, isArray, flattenDeep, uniq } from 'lodash-es';

interface FormErrorRecord {
  [key: string]: FormError;
}

type FormError = string[] | FormErrorRecord;

function collectMessages(messages: FormError | string | undefined) {
  if (!messages) return [];
  const collectedMessages = [];
  if (!isArray(messages)) {
    forIn(messages, (message) => {
      if (typeof message === 'number') return;
      collectedMessages.push(collectMessages(message as any));
    });
  } else {
    collectedMessages.push(messages);
  }
  return uniq(flattenDeep(collectedMessages));
}

export type FormErrorListProps = {
  errors?: FormError;
};

const props = withDefaults(defineProps<FormErrorListProps>(), {
  errors: undefined,
});

const messages = computed(() => collectMessages(props.errors));

const isVisible = computed(() => messages.value.length > 0);

defineExpose({
  isVisible,
  messages,
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.form-error-list {
  padding-top: 1.5 * $grid-base;
  padding-bottom: 1.5 * $grid-base;

  @include mq($mq-sm) {
    padding-top: 2.5 * $grid-base;
    padding-bottom: 2.5 * $grid-base;
  }
}
</style>
